/* unplugin-vue-components disabled */import script from "./RechargeRuleRewardPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargeRuleRewardPopup.vue?vue&type=script&setup=true&lang=js"

import "./RechargeRuleRewardPopup.vue?vue&type=style&index=0&id=f1954db0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1954db0"]])

export default __exports__